import { Gender } from "@./cat-calculations";
import { formatCatNames } from "apps/website/utils/misc/strings";

interface IPronouns {
  pronoun: "he" | "she" | "they";
  possessivePronoun: "his" | "her" | "their";
  objectPronoun: "him" | "her" | "them";
}

const PRONOUNS: Record<Gender, IPronouns> = {
  BOY: { pronoun: "he", possessivePronoun: "his", objectPronoun: "him" },
  GIRL: { pronoun: "she", possessivePronoun: "her", objectPronoun: "her" },
  UNKNOWN: { pronoun: "they", possessivePronoun: "their", objectPronoun: "them" },
};

export const getInterpolationVariables = ({ name, gender, names }:
{ name?: string, gender?: Gender, names?: string[] }) => {
  const pronouns = PRONOUNS[gender ?? "UNKNOWN"];

  return {
    pronoun: pronouns.pronoun,
    possessivePronoun: pronouns.possessivePronoun,
    objectPronoun: pronouns.objectPronoun,
    catName: name ?? "",
    catNames: formatCatNames(names ?? []) ?? "",
  };
};
